import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M17 16c0-2.654.69-5.205 1.98-7.456.466-.81-.336-1.76-1.213-1.436A18 18 0 0 0 6 24c0 9.943 8.058 18 18 18a18 18 0 0 0 16.892-11.767c.323-.877-.626-1.679-1.436-1.213A14.9 14.9 0 0 1 32 31c-8.285 0-15-6.714-15-15m7 24c-8.837 0-16-7.162-16-16 0-5.843 3.16-11.09 8.048-13.89A17 17 0 0 0 15 16c0 9.39 7.61 17 17 17 2.039 0 4.026-.36 5.89-1.048A16 16 0 0 1 24 40",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "mask",
    {
      id: "Moon-Outlined_svg__a",
      width: 35,
      height: 35,
      x: 6,
      y: 7,
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M17 16c0-2.654.69-5.205 1.98-7.456.466-.81-.336-1.76-1.213-1.436A18 18 0 0 0 6 24c0 9.943 8.058 18 18 18a18 18 0 0 0 16.892-11.767c.323-.877-.626-1.679-1.436-1.213A14.9 14.9 0 0 1 32 31c-8.285 0-15-6.714-15-15m7 24c-8.837 0-16-7.162-16-16 0-5.843 3.16-11.09 8.048-13.89A17 17 0 0 0 15 16c0 9.39 7.61 17 17 17 2.039 0 4.026-.36 5.89-1.048A16 16 0 0 1 24 40",
        clipRule: "evenodd"
      }
    )
  ),
  /* @__PURE__ */ React.createElement("g", { mask: "url(#Moon-Outlined_svg__a)" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 0h48v48H0z" }))
);
var SvgMoonOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MoonOutlined_default = SvgMoonOutlined;

export { MoonOutlined_default as default };
